import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CALLES_DE_CALADO } from '../../../../config/tables'

function TablaCallesDeCaladoView () {
  return (
    <MuiTable id={TABLA_CALLES_DE_CALADO} />
  )
}

export default TablaCallesDeCaladoView
